export const FILTER_TYPE = {
    BROKER: 'broker',
    CONTACT_TYPE: 'contact type',
    SEARCH: 'search',
}